import { Badge, Button } from "@mui/material";
import { ButtonRow } from "@synota-io/synota-shared-ui";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { RequestQuoteOutlined } from "@mui/icons-material";
import { SearchStateLink } from "../../../../shared/layout/SearchStateLink";
import { generatePath } from "react-router-dom";
import { CONTRACT_ADHOC_INVOICES_PATH } from "../../../../paths";

export const CONTRACT_UNAPPROVED_ADHOC_TITLE = "Contract has pending adhoc invoices";

export const ContractActionsCell = ({ contract }: { contract: IDashboardContract }) => {
  if (!contract.unapproved_additional_charges) {
    return null;
  }

  return (
    <ButtonRow>
      <Button
        title={CONTRACT_UNAPPROVED_ADHOC_TITLE}
        component={SearchStateLink}
        color="primary"
        to={generatePath(CONTRACT_ADHOC_INVOICES_PATH, {
          id: contract.shared_uuid,
        })}
      >
        <Badge badgeContent={contract.unapproved_additional_charges || undefined} color="warning">
          <RequestQuoteOutlined />
        </Badge>
      </Button>
    </ButtonRow>
  );
};
